"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  storedValue: _propTypes["default"].string.isRequired,
  eventHandler: _propTypes["default"].shape({
    handleUpdate: _propTypes["default"].func.isRequired,
    onChange: _propTypes["default"].func.isRequired,
    onKeyPress: _propTypes["default"].func.isRequired
  }).isRequired,
  fieldData: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    fieldKey: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    options: _propTypes["default"].array.isRequired,
    validation: _propTypes["default"].shape({
      message: _propTypes["default"].string.isRequired,
      pattern: _propTypes["default"].string.isRequired
    }).isRequired,
    value: _propTypes["default"].string.isRequired
  }).isRequired
};
exports["default"] = _default;